import React, { useState, useEffect } from "react";
import "../style/cpeTable.css";
import Pagination from "./Pagination";
import _ from "lodash";
import http from "../services/httpService.js";
import { toast } from "react-toastify";
const { SERVER_BASE_URL } = require("../env");

function ProgramTable({
  items,
  makeLoadingOfAdditionTrue,
  makeLoadingOfAdditionFalse,
}) {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [cpes, setCPEs] = useState([]);
  const [error, setError] = useState("");

  const handleAdd = async (item) => {
    console.log(item.cpe.cpeName);

    let englishTitle = item.cpe.titles.filter((o) => o.lang === "en");
    englishTitle = englishTitle[0].title;

    makeLoadingOfAdditionTrue();
    try {
      const response = await http.post(
        `${SERVER_BASE_URL}/my-cpes`,
        {
          cpeName: item.cpe.cpeName,
          cpeId: item.cpe.cpeNameId,
          title: englishTitle,
        },
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      );

      toast.success(`اضافه شد ${item.cpe.titles[0].title}`);
      makeLoadingOfAdditionFalse();
    } catch (e) {
      if (e.response && e.response.status == 400) {
        setError(e.response.data.error);
        toast.error(e.response.data.error);
      }
      if (e.response && e.response.status == 503) {
        setError(e.response.data.error);
        toast.error(e.response.data.error);
      }
      makeLoadingOfAdditionFalse();
    }
  };

  const handleOnPageClick = (number) => {
    setCurrentPage(number);
  };

  const paginate = () => {
    const start = (currentPage - 1) * pageSize;
    return _(items).slice(start).take(pageSize).value();
  };

  useEffect(() => {
    const paginatedCPEsArray = paginate(items);
    setCPEs(paginatedCPEsArray);
  }, [items, currentPage]);

  return (
    <div className="table_container">
      <div className="align-center">
        برنامه مورد نظرتان را از لیست زیر انتخاب کنید
      </div>
      <table className="table farsi">
        <thead>
          <tr>
            <th></th>
            <th />
          </tr>
        </thead>
        <tbody>
          {cpes.map((p) => (
            <tr className="program-table-item" key={p.cpe.cpeNameId}>
              <td className="col-1">
                <i
                  className="fa fa-plus plus-icon"
                  onClick={() => handleAdd(p)}
                  aria-hidden="true"
                ></i>
              </td>
              <td className="col-11 row-title ltr">{p.cpe.cpeName}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        className="pagination-container"
        countOfItems={items.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageClicked={handleOnPageClick}
      ></Pagination>
    </div>
  );
}

export default ProgramTable;
